module.exports = "./img/3c4f26b7d0fb5ab5cfa8e2e9e6b69364.png";